<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <h2 class="m0 caps">choisissez un produit</h2>
    </div>
    <div v-if="products.some(product => (product.areas || []).some(area => area.name.toUpperCase() === 'ESCAPE GAME'))">
      <ProductList @product-selected="productSelected" />
      <div ref="sessionButton" class="col-12 py3 flex justify-end items-center">
        <Button class="col-4 sm-col-6" :action="handleBack" text="Retour" color="grey-bg" />
        <Button v-if="!loading && products.length > 0" class="col-4 sm-col-6 ml2" :action="forward" :disabled="selectedProduct === null" text="Suivant" />
        <Button v-else-if="loading" class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
    <div v-else>
      <ProductsCard @offer-selected="offerSelected" />
      <div ref="sessionButton" class="col-12 py3 flex justify-end items-center">
        <Button class="col-4 sm-col-6" :action="handleBack" text="Retour" color="grey-bg" />
        <Button v-if="!loading && products.length > 0" class="col-4 sm-col-6 ml2" :action="suivant" :disabled="selectedProduct === null && selectedOffer === null" text="Suivant" />
        <Button v-else-if="loading" class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/elements/Button';
// import { getProduct } from '@/utils/requests';
// import { generateImageUrl } from '@/utils/utils';

import { changeToPage, handleProduct, handleEscapeProduct } from '@/utils/logics';
import ProductList from '@/components/products/ProductList.vue';
import ProductsCard from '@/components/products/ProductsCard.vue';
import { backToAlpha } from '@/utils/utils';

export default {
  components: {
    Button,
    ProductsCard,
    ProductList
  },
  data () {
    return {
      loading: false,
      selectedProduct: null,
      selectedOffer: null
    };
  },
  computed: {
    products () {
      return this.$store.state.products;
    }
  },
  methods: {
    backToAlpha,
    handleProduct,
    changeToPage,
    handleBack () {
      this.backToAlpha();
    },
    async suivant () {
      this.loading = true;
      if (this.selectedProduct && this.selectedOffer) {
        await this.handleProduct(this.selectedProduct, this.selectedOffer);
        this.changeToPage('Terrain');
        this.loading = false;
      }
    },
    async forward () {
      this.loading = true;
      if (this.selectedProduct) {
        await handleEscapeProduct(this.selectedProduct);
        this.changeToPage('OfferList');
        this.loading = false;
      }
    },
    offerSelected ({ product, offerCode }) {
      this.selectedProduct = product;
      this.selectedOffer = offerCode;
    },
    productSelected (product) {
      this.selectedProduct = product;
    }
  }
};
</script>

<style lang="scss" scoped>
.shadow {
  box-shadow: 0px 2px 5px 1px #ddd;
}
.line-height-0 {
  line-height: 0;
}
</style>
